import React from 'react';

/** 小型开关：用于列表自动规则等开/关。 */
export default function TemuSwitch({
  checked = false,
  disabled = false,
  onChange,
  ariaLabel = '',
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      className={`tpo-switch${checked ? ' is-on' : ''}`}
      disabled={disabled}
      onClick={(e) => {
        e.stopPropagation();
        if (disabled) return;
        onChange?.(!checked);
      }}
    >
      <span className="tpo-switch__thumb" aria-hidden="true" />
    </button>
  );
}
